var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Doc"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 1.25C3.82417 1.25 3.125 1.95 3.125 2.8125V17.1875C3.125 18.05 3.825 18.75 4.6875 18.75H15.3125C16.175 18.75 16.875 18.05 16.875 17.1875V10.625C16.875 9.7962 16.5458 9.00134 15.9597 8.41529C15.3737 7.82924 14.5788 7.5 13.75 7.5H12.1875C11.7731 7.5 11.3757 7.33538 11.0826 7.04235C10.7896 6.74933 10.625 6.3519 10.625 5.9375V4.375C10.625 3.5462 10.2958 2.75134 9.70971 2.16529C9.12366 1.57924 8.3288 1.25 7.5 1.25H4.6875Z",
    fill: "#06070D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8092 1.51333C11.4979 2.30747 11.8765 3.32379 11.875 4.375V5.9375C11.875 6.11 12.015 6.25 12.1875 6.25H13.75C14.8012 6.24854 15.8175 6.62707 16.6117 7.31583C16.245 5.92142 15.5146 4.64942 14.4951 3.62991C13.4756 2.6104 12.2036 1.87997 10.8092 1.51333Z",
    fill: "#06070D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.09b4a82d96e29d0dd784c597168e9441.svg";
export { ForwardRef as ReactComponent };